import { render, staticRenderFns } from "./Undertake.vue?vue&type=template&id=f0a1bae8&scoped=true&"
import script from "./Undertake.vue?vue&type=script&lang=js&"
export * from "./Undertake.vue?vue&type=script&lang=js&"
import style0 from "./Undertake.vue?vue&type=style&index=0&id=f0a1bae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a1bae8",
  null
  
)

export default component.exports